import React, { ReactElement, useState, useRef, useEffect } from "react";

const DropdownGroup = ({ children }: { children: ReactElement[] | ReactElement }) => {
	const [openedDropdown, setOpenedDropdown] = useState(null as number);
	const node = useRef();

	let classesToIgnore = ["filterAttributes"];

	const onClick = (index: number) => {
		return function() {
			if (openedDropdown !== index) {
				setOpenedDropdown(index);
			} else {
				setOpenedDropdown(null);
			}
		};
	};

	const containsIgnoredClasses = (classList: DOMTokenList): boolean => {
		for (let classToIgnore of classesToIgnore) {
			if (classList.contains(classToIgnore)) {
				return true;
			}
		}

		return false;
	};

	//https://codesandbox.io/s/9o3lw5792w
	const handleClickOutside = e => {
		//@ts-ignore
		if (node.current.contains(e.target) && !containsIgnoredClasses(e.target.classList)) {
			// inside click
			return;
		}
		// outside click
		setOpenedDropdown(null);
	};

	useEffect(() => {
		//@ts-ignore
		//classesToIgnore = node.current.classList.values();

		if (openedDropdown !== null) {
			document.addEventListener("mousedown", handleClickOutside);
		} else {
			document.removeEventListener("mousedown", handleClickOutside);
		}

		return () => {
			document.removeEventListener("mousedown", handleClickOutside);
		};
	}, [openedDropdown]);

	const close = () => {
		setOpenedDropdown(null);
	};

	return (
		<div className="filterAttributes" ref={node}>
			{React.Children.map(children, (child, index) => {
				return React.cloneElement(child, {
					...child.props,
					onClick: onClick(index),
					isOpen: index === openedDropdown,
					close,
				});
			})}
		</div>
	);
};

export default DropdownGroup;
